import Report1OnlineInfo from './OnlineChartOptions/Report1OnlineInfo';
import Report2OnlineInfo from './OnlineChartOptions/Report2OnlineInfo';
import Report3OnlineInfo from './OnlineChartOptions/Report3OnlineInfo';
import Report4OnlineInfo from './OnlineChartOptions/Report4OnlineInfo';
import Report7OnlineInfo from './OnlineChartOptions/Report7OnlineInfo';
import Report8OnlineInfo from './OnlineChartOptions/Report8OnlineInfo';
import Report31OnlineInfo from './OnlineChartOptions/Report31OnlineInfo';
import Report32OnlineInfo from './OnlineChartOptions/Report32OnlineInfo';
import Report36OnlineInfo from './OnlineChartOptions/Report36OnlineInfo';
import Report48OnlineInfo from './OnlineChartOptions/Report48OnlineInfo';
import Report59OnlineInfo from './OnlineChartOptions/Report59OnlineInfo';

export default function OnlineInfoSwitch({ data }) {
  switch (data.reportType) {
    case 1:
      return <Report1OnlineInfo data={data} />;
    case 2:
      return <Report2OnlineInfo responseData={data} />;
    case 3:
      return <Report3OnlineInfo responseData={data} />;
    case 4:
      return <Report4OnlineInfo responseData={data} />;
    case 7:
      return <Report7OnlineInfo responseData={data} />;
    case 8:
      return <Report8OnlineInfo responseData={data} />;
    case 31:
      return <Report31OnlineInfo responseData={data} />;
    case 32:
      return <Report32OnlineInfo responseData={data} />;
    case 36:
      return <Report36OnlineInfo data={data} />;
    case 48:
      return <Report48OnlineInfo responseData={data} />;
    case 59:
      return <Report59OnlineInfo data={data} />;
    default:
      return <></>;
  }
}